/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Problem_TitleInputs */

const en_mk_problem_title = /** @type {(inputs: Mk_Problem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why AI adoption stalls in your team`)
};

const id_mk_problem_title = /** @type {(inputs: Mk_Problem_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kenapa adopsi AI macet di timmu?`)
};

/**
* | output |
* | --- |
* | "Why AI adoption stalls in your team" |
*
* @param {Mk_Problem_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_problem_title = /** @type {((inputs?: Mk_Problem_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Problem_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_problem_title(inputs)
	return en_mk_problem_title(inputs)
});